/* eslint-disable no-multi-assign */

'use-strict';

import angular, { IScope } from 'angular';
import { InterfaceService } from '../../shared/interface/interface.service';
import { PermissionsService } from '../../components/authorization/permissions.service';
import { UserRole } from '../../src/app/@shared-types/user';

export interface BackdropItem {
  title: string,
  icon: string,
  selected: boolean,
  active: boolean,
}

/* @ngInject */
export default class BackdropRailController {
  private jump!: string;

  private changeFunction?: (data: { item: string }) => void;

  public mainAction?: () => void;

  public mainIcon?: string;

  public mainPermissions?: string;

  private interfaceService: InterfaceService;

  private permissionsService: PermissionsService;

  private elements: { [key: string]: JQLite } = {}; // holds the DOM elements from BackdropItem

  private items: BackdropItem[] = []; // holds the BackdropItems

  private jumpMode: boolean;

  private throttleWait = false;

  private $scope: IScope;

  private currentlyActiveItem!: BackdropItem;

  public permissionForMainAction = false;

  constructor(
    $scope: IScope,
    interfaceService: InterfaceService,
    permissionsService: PermissionsService,
  ) {
    this.$scope = $scope;
    this.interfaceService = interfaceService;
    this.permissionsService = permissionsService;
    this.jumpMode = this.jump === 'true';
  }

  $onInit(): void {
    this.jumpMode = this.jump === 'true';

    if (this.mainPermissions) {
      const roles = this.mainPermissions.split(',').map((r) => parseInt(r, 10));
      this.permissionForMainAction = this.permissionsService.isPermitted(roles as any);
    }
  }

  /** Cycles through all backdrop items and set's the currently actives icon as highlighted. */
  private checkActiveIcon = () => {
    let activeItem = this.items[0];

    angular.forEach(this.items, (i) => {
      const elementForItem = this.elements[i.title];
      const domElement = document.querySelector('main.main');
      if (!domElement) return;
      if (domElement.scrollTop > elementForItem.prop('offsetTop')) {
        activeItem = i;
      }
    });

    return this.activateItem(activeItem);
  };

  /** Select a backdrop item with the supplied id. */
  private selectItem = (item: BackdropItem): void => {
    if (this.jumpMode) {
      const elem = this.elements[item.title];
    } else {
      angular.forEach(this.items, (i) => {
        i.selected = i.active = false;
      });

      const selectedItem = this.items.find((i) => i.title === item.title);
      if (selectedItem !== undefined) {
        selectedItem.selected = true;
        selectedItem.active = true;
      }
    }

    const mainElement = document.querySelector('main.main');
    if (!mainElement) return;
    mainElement.scrollTop = 0;

    this.interfaceService.applyScope(this.$scope);

    if (this.changeFunction) {
      this.changeFunction({ item: item.title });
    }
    this.checkActiveIcon();
  };

  private activateItem = (item: BackdropItem) => {
    if (this.currentlyActiveItem === item) return;
    this.currentlyActiveItem = item;

    angular.forEach(this.items, (i) => {
      i.active = false;
    });

    if (item !== undefined) item.active = true;
    this.interfaceService.applyScope(this.$scope);
  };

  private throttle = (callback: () => void, time: number) => {
    if (this.throttleWait) return;
    this.throttleWait = true;

    setTimeout(() => {
      callback();
      this.throttleWait = false;
    }, time);
  };

  private registerScrollListener = () => {
    document.addEventListener('wheel', () => {
      this.throttle(() => {
        this.checkActiveIcon();
      }, 250);
    }, { passive: false });
  };

  /** BackdropItem directives call this method via the link function  */
  public registerItem = (item: BackdropItem, elem: JQLite): void => {
    this.elements[item.title] = elem;
    this.items.push(item);

    if (this.items.length === 1 && !this.jumpMode) this.selectItem(item);
    if (this.items.length === 1 && this.jumpMode) this.activateItem(item);
    if (this.jumpMode) item.selected = true;

    if (this.jumpMode) this.registerScrollListener();
    this.interfaceService.applyScope(this.$scope);
  };

  public navigate = (url: string): void => this.interfaceService.navigateToUrl(url);
}
